define(function (require) {
    var $ = require("jquery");
    var introJs = require("intro-js");
    /* the following vars are defined in the Sitecore rendering
    var watchdogTimerMilliseconds = 540000; // 9 minutes // idleTimer       // in Sitecore this is: MinutesUntilAlertDisplayed
    var alertDisplayMilliseconds = 60000; // 60 seconds  // autoLogoutTimer // in Sitecore this is: SecondsUntilAlertClosedAndAutoLogoff
    var logoffDestinationUrl = "/";
    */
    var idleTimer, autoLogoutTimer;

    function logoutUser() {
        if (autoLogoutTimer != null) {
            clearTimeout(autoLogoutTimer);
        }
        console.log("log the user off at the server");
        $.ajax({
            type: "GET",
            url: "/handlers/SessionHeartbeat.ashx?logout=1",
            data: "",
            contentType: "application/json; charset=utf-8",
            dataType: "json",
            complete: function () {
                var sessionModalEl = document.getElementById("sessionTimeout");
                var sessionModal = bootstrap.Modal.getInstance(sessionModalEl);
                sessionModal.hide();
                window.location.href = logoffDestinationUrl;
            }
        });
    }

    function sendKeepAliveTickleToServerAndRestartTimer(shouldHideModal) {
        // tickle the server
        console.log("tickling the server to tell it to NOT log me out");
        $.ajax({
            type: "GET",
            url: "/handlers/SessionHeartbeat.ashx",
            data: "",
            contentType: "application/json; charset=utf-8",
            dataType: "json",
            complete: function () {
                if (shouldHideModal) {
                    // hide the dialog and reset the watchdog timer
                    var sessionModalEl = document.getElementById("sessionTimeout");
                    if (sessionModalEl) {
                        var sessionModal = bootstrap.Modal.getInstance(sessionModalEl);
                        if (sessionModal) {
                            sessionModal.hide();
                        }
                    }
                }

                clearTimeout(idleTimer);
                idleTimer = setInterval(confirmStay, watchdogTimerMilliseconds);
            }
        });
    }

    function confirmStay() {
        console.log("confirmStay()");
        clearTimeout(idleTimer);

        // close any guided tours in place
        introJs.introJs().exit();

        // close the MFA modal if it's open
        if (document.getElementById("mfaModal")) {
            var myModalEl = document.getElementById("mfaModal");
            var mfaModal = bootstrap.Modal.getInstance(myModalEl);
            mfaModal.hide();
        }

        // close datepicker and any modals that may be open
        $("#readingDate").datepicker("hide");
        $(".modal").modal("hide"); // close all open modals

        // show the timeout modal and handle yes/no button click events
        $("#sessionTimeout")
            .on("click", "#sessionTimeoutYes", function () {
                clearTimeout(autoLogoutTimer);
                sendKeepAliveTickleToServerAndRestartTimer(true);
            })
            .on("click", "#sessionTimeoutNo", logoutUser);

        var sessionModal = new bootstrap.Modal(document.getElementById("sessionTimeout"), {
            backdrop: "static"
        });
        sessionModal.show();

        // begin auto-logout timer
        autoLogoutTimer = setInterval(logoutUser, alertDisplayMilliseconds);
    }

    function restartTimer() {
        console.log("mouse movement triggering keep-alive");
        sendKeepAliveTickleToServerAndRestartTimer(false);
    }

    // Debounce function, to prevent multiple rapid calls to startTimer
    function debounce(fn, delay) {
        let timer = null;
        return function () {
            const context = this,
                args = arguments;
            clearTimeout(timer);
            timer = setTimeout(() => {
                fn.apply(context, args);
            }, delay);
        };
    }

    // only set this up if the session timeout DIV is on the page
    if ($("#sessionTimeout").length) {
        idleTimer = setInterval(confirmStay, watchdogTimerMilliseconds);
        // restart idleTimer if the mouse moves
        if (typeof watchdogTimerMilliseconds !== "undefined") {
            // Create a debounced version of the startTimer function
            const debouncedStartTimer = debounce(restartTimer, watchdogTimerMilliseconds * 0.45);
            window.addEventListener("mousemove", debouncedStartTimer);
        }
    }
});
